import ReactComponent from '../app/ReactComponent'
import {$language, _$t} from '../app/Languages'
import {$app} from '../app'
import {Spin} from 'antd'

export default class DataProtectionPage extends ReactComponent {
  state = {
    loading: false,
    content: ''
  }

  async componentDidMount() {
    const active_lang = $language().$language()

    await this.updateState({loading: true})

    try {

      const res = await $app.$directus('content', {
        fields: ['*', {translations: ['languages_code', 'content']}],
        deep: {
          translations: {
            _filter: {
              languages_code: {'_eq': active_lang}
            }
          }
        }
      })

      res.forEach((item) => {
        if(item.key === 'personal_data_protection_policy')
          void this.updateState({
            content: item.translations[0].content,
            loading: false,
          })
      })

    } catch (e) {
      $app.$e(e)
    }
  }

  render() {
    return (
      <>
        <div className="silencer"><br/></div>
        <Spin spinning={this.state.loading} size="large">
          <section className="container centered mt-4">
            <div className="card-grey formatted">
              <div dangerouslySetInnerHTML={{__html: this.state.content}}></div>
            </div>
          </section>
        </Spin>
      </>
    )
  }
}